import React, { useState } from 'react';

import { parseStyle } from '../../util/parseStyle';

import plus from '../../assets/images/icon/common_style/plus.png';
import minus from '../../assets/images/icon/common_style/minus.png';

type Props = {
	children: React.ReactNode;
	labelName: string;
	value: any;
	label?: boolean;
	isOpen?: boolean;
}

function FieldSectionToggle({ children, labelName, label, isOpen, value }: Props) {

	const [open, setOpen] = useState(isOpen ? isOpen : false); // default: false

	const toggleOpen = () => {
		setOpen(!open);
	}

	return (
		<section className="field-section-toggle">
			<header className="field-section-toggle-header" onClick={toggleOpen}>
				{ 
					labelName === '구분선' ? (
						<>
						<strong>
							<span>{labelName}</span>
							<span className="partition" style={parseStyle(value)} />
						</strong>
						</>
					) : (
						<strong
							style={parseStyle(value)}
							data-label-name={labelName}
						>
							{labelName}
						</strong>
					)
				}
				<button>
					<img src={open ? minus : plus} width="15" />
				</button>
			</header>
			<div className={open ? 'field-section-toggle-body active' : 'field-section-toggle-body'}>
				<div className="field-section-toggle-body-inner">
					{children}
				</div>
			</div>
		</section>
	)
}

export default FieldSectionToggle;